<template>
  <HubContainer id="externalPosHub">

    <template v-if="atLeastDistributor">
      <HubSection large icon="icon/hub/external-pos.svg"
                  :title="$t('configuration')"
                  :description="$t('companies.settings.externalPos_description')"
                  :buttonAction="goToExternalPos">
      </HubSection>

      <HubSection large icon="icon/hub/ssh-tunnel.svg"
                  :title="$t('companies.settings.tunnel')"
                  :description="$t('companies.settings.tunnel_description')"
                  :buttonAction="goToTunnel">
      </HubSection>
    </template>

  </HubContainer>
</template>

<script>
  import HubSection from "@/components/HubSection";
  import HubContainer from "@/components/HubContainer";

  export default {
    name: "externalPosHub",

    components: {HubSection, HubContainer},

    mounted() {
      this.$store.state.pageTitleTranslationKey = "companies.settings.externalPos";
      this.$store.state.pageIcon = "/icon/nav/analytics.svg";
    },

    computed: {
      atLeastSuperAdmin() {
        return this.$store.getters.loggedUserHasSuperAdmin;
      },
      atLeastDistributor() {
        return this.$store.getters.loggedUserHasDistributor;
      }
    },

    methods: {
      goToExternalPos() {
        this.$router.push(this.$router.buildContext("/settings/external-pos"));
      },
      goToTunnel() {
        this.$router.push(this.$router.buildContext("/settings/tunnel"));
      }
    }
  }
</script>